import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ResponseAgreementDto } from 'generated/apex-rest';
import { Tenancy } from 'projects/apex/src/app/models/tenancy';
import { Subscription } from 'rxjs';
import { PageInfoModule } from '../../../../../apex/src/app/components/page-info/page-info.module';
import { TranslateModule } from '../../../../../apex/src/app/components/translate/translate.module';
import { PortalAgreementListComponent } from './portal-agreement-list.component';
import { PortalAgreementService } from './portal-agreement.service';

@Component({
  selector: 'portal-tenancy-agreement',
  templateUrl: './portal-tenancy-agreement-page.component.html',
  standalone: true,
  imports: [CommonModule, TranslateModule, PageInfoModule, PortalAgreementListComponent],
  providers: [PortalAgreementService],
})
export default class PortalTenancyAgreementPageComponent implements OnInit, OnDestroy {
  tenancy: Tenancy;
  agreements: ResponseAgreementDto[] = [];
  loading = true;

  subscription = new Subscription();

  constructor(
    private route: ActivatedRoute,
    private portalAgreementService: PortalAgreementService,
  ) {}

  async ngOnInit(): Promise<void> {
    this.tenancy = this.route.snapshot.data['tenancy'];
    await this.loadTenantAgreements();
  }

  async loadTenantAgreements(): Promise<void> {
    try {
      this.loading = true;
      this.agreements = await this.portalAgreementService.getAllAgreements();
    } catch (error) {
      console.error('Failed to load agreements:', error);
      this.agreements = [];
    } finally {
      this.loading = false;
    }
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
